// import './wdyr';
import './process-polyfill';
import React from 'react';
import * as Sentry from '@sentry/browser';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import fetchIntercept from 'fetch-intercept';
import { ToastContainer, Slide } from 'react-toastify';
import { Helmet } from 'react-helmet';
import { store, persistor } from 'src/core';
import { SIGN_OUT } from 'src/auth';
import 'src/ui/fontawesome';
import 'react-toastify/dist/ReactToastify.css';
import 'react-datepicker/dist/react-datepicker.css';
import 'react-quill/dist/quill.snow.css';
import 'react-table/react-table.css';
import 'src/ui/styles/styles.scss';
import App from './App';
import { SvgGradients } from './ui';

if (process.env.NODE_ENV !== 'development') {
  Sentry.init({
    dsn: 'https://b42ea7ec928b405dac64669e95a48a24@sentry.io/1543208',
    environment: process.env.NODE_ENV, // Optional
    tracesSampleRate: 0.0, // Disable performance monitoring
    replaysSessionSampleRate: 0.0, // Disable session replay
    replaysOnErrorSampleRate: 0.0, // Disable error replay
  });
}

fetchIntercept.register({
  response(response) {
    if (response.status === 401) {
      if (process.env.NODE_ENV !== 'development') {
        Sentry.captureMessage(
          `Response 401 received for api call: ${response.url}`
        );
      }
      store.dispatch({ type: SIGN_OUT });
    }

    return response;
  },
});

// Create a root once
const rootElement = document.getElementById('root');
const root = createRoot(rootElement);

const render = () => {
  root.render(
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <BrowserRouter>
          <>
            <Helmet />
            <SvgGradients />
            <App />
            <ToastContainer
              position="top-center"
              closeButton={false}
              transition={Slide}
            />
          </>
        </BrowserRouter>
      </PersistGate>
    </Provider>
  );
};

store.subscribe(render);
render();
